module.exports = __webpack_public_path__ + "icon-edit.svg?7643c7dd7886609f7726a185bda2f5f2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-edit.svg
// module id = 607
// module chunks = 0